<template>
  <GenericStep v-bind="$attrs">
    <ParentsCard
      v-for="parent of peParty.parents"
      :key="parent.id"
      class="mb-4"
      :form-only="true"
      :item="parent"
    />

    <SectionAdderLine
      section="Parent"
      :has-new-section="peParentsCardHasNewSection"
      @on-add="peParentsCardAddSection"
    />
  </GenericStep>
</template>

<script>
import { cloneDeep, isEqual } from 'lodash'
import { mapActions, mapGetters } from 'vuex'

import { PARTY_NAMESPACE } from '@/store/party'

import GenericStep from '@/components/Party/QuickInterview/GenericStep.vue'
import ParentsCard from '@/components/Party/PartyEdit/SectionCards/FamiliesCards/ParentsCard.vue'
import SectionAdderLine from '@/components/Party/PartyEdit/SectionTools/SectionAdderLine.vue'

export default {
  name: 'ParentsStep',

  components: {
    GenericStep,
    ParentsCard,
    SectionAdderLine,
  },

  inheritAttrs: false,

  data () {
    return {
      hasChanged: false,
      originalData: null,
    }
  },

  computed: {
    relevantFields () {
      return this.peParty.parents
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peParentsCardHasNewSection',
      'peParty',
    ]),
  },

  watch: {
    relevantFields (value) {
      if (!this.hasChanged && !isEqual(value, this.originalData)) {
        this.hasChanged = true
        this.$emit('changed', true)
      }
    },
  },

  created () {
    this.originalData = cloneDeep(this.relevantFields)
  },

  methods: {
    ...mapActions(PARTY_NAMESPACE, [
      'peParentsCardAddSection',
    ]),
  },
}
</script>
